/* Andy Cooks - keeps the Essential Free Shipping bottom bar and Raptive's ads out of each other's way.
   1. When a Raptive footer ad (.adthrive-footer) is showing at the bottom of the screen, the bar sits directly on
      top of it; with no ad (or once it's closed) the bar drops back to the bottom. Sets --ac-ad-footer on <html>.
   2. When Raptive's floating video player is pinned to the bottom corner and would cover the bar, it's lifted
      by the bar's height so both stay visible.
   Used by assets/ac-shipping-bar.css. Loaded from snippets/ac-fonts.liquid. */
(function () {
  if (window.__acShipAd) return;
  window.__acShipAd = true;
  var root = document.documentElement, last = -1, raf = 0;

  function shown(el) {
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    var r = el.getBoundingClientRect();
    return (r.height < 1 || r.width < 1) ? null : r;
  }

  function footerHeight() {
    var els = document.querySelectorAll('.adthrive-footer, [id^="AdThrive_Footer"]');
    var h = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i], pos = getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var r = shown(el);
      if (!r || r.bottom < window.innerHeight - 4) continue; /* not pinned to the bottom */
      h = Math.max(h, Math.round(window.innerHeight - r.top));
    }
    return h;
  }

  function liftPlayers(barTop, barH) {
    var els = document.querySelectorAll('.raptive-player-container, .adthrive-collapse-player, .adthrive-player-position, [id^="cls-video-container"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var fixed = getComputedStyle(el).position === 'fixed';
      var lifted = el.dataset.acLift === '1';
      if (!fixed || !barH) { if (lifted) { el.style.translate = ''; delete el.dataset.acLift; } continue; }
      var r = shown(el);
      if (!r) continue;
      var bottom = lifted ? r.bottom + barH : r.bottom; /* where it would sit without our lift */
      if (bottom > barTop + 1) {
        if (!lifted) { el.style.translate = '0 -' + barH + 'px'; el.dataset.acLift = '1'; }
      } else if (lifted) { el.style.translate = ''; delete el.dataset.acLift; }
    }
  }

  function update() {
    raf = 0;
    var h = footerHeight();
    if (h !== last) {
      last = h;
      root.style.setProperty('--ac-ad-footer', h + 'px');
      root.classList.toggle('ac-has-ad-footer', h > 0);
    }
    var bar = document.querySelector('.essential_free_shipping_bar_wrapper');
    var br = bar && getComputedStyle(bar).position === 'fixed' ? shown(bar) : null;
    liftPlayers(br ? br.top : 0, br ? Math.round(br.height) : 0);
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(update); }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('click', function () { setTimeout(schedule, 50); setTimeout(schedule, 400); }, true);
  schedule();
})();
